import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { sampleReportKeys } from "../queryKeys";
import api from "./../services/api";

const useVisualization = (hash: string) => {
  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();

  const query = useQuery({
    queryKey: sampleReportKeys.visualization(hash),
    queryFn: () => api.getVisualization(hash, source.token),
    refetchOnWindowFocus: false,
    refetchInterval: false
  });

  return { query, source };
};

export default useVisualization;
